import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { RouterLink, RouterLinkActive } from '@angular/router';
import { CommonModule, NgFor } from '@angular/common';
import { MatRipple } from '@angular/material/core';
import { ENVIRONMENT } from '../environment/environment';
import { RxFor } from '@rx-angular/template/for';
import { IconComponent } from '../icons/icon/icon.component';


@Component({
  selector: 'lib-social',
  standalone: true,
  imports: [CommonModule, RouterLink, RouterLinkActive ,RxFor, MatRipple, IconComponent, NgFor],
  templateUrl: './social.component.html',
  styleUrl: './social.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class SocialComponent {
  readonly socials = inject(ENVIRONMENT).socials;
}
